import { useQuery } from '@tanstack/react-query';
import { createHttpClient } from '@adapters/HttpClient';
import { apiClientWH } from '@shared/services';
import { SuscriptionApiAdapter } from '../adapters/SuscriptionApiAdapter';
import { Service } from '../services/Service';

export const useSuscription = () => {
  const httpClient = createHttpClient(apiClientWH);
  const apiAdapter = new SuscriptionApiAdapter(httpClient);
  const service = new Service(apiAdapter);

  // Hook para obtener el link del portal de Stripe
  const {
    data: stripePortalUrl,
    isLoading: isLoadingStripe,
    error: errorStripe,
    refetch: refetchStripe,
  } = useQuery({
    queryKey: ['stripe-portal'],
    queryFn: () => service.getStripePortal(),
  });

  return {
    stripePortalUrl,
    isLoading: isLoadingStripe,
    error: errorStripe,
    refetch: refetchStripe,
  };
};
